import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "sun, light-mode, day, today",
      "clip-path": "url(#clip0_15263_8704)"
    }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M10.2502 2.74237V1.47299M5.11821 15.1322L4.22062 16.0298M10.2502 18.5273V17.2579M16.2795 3.97058L15.3819 4.86816M17.5075 10.0001H18.7769M15.3819 15.1321L16.2795 16.0297M1.72302 10.0001H2.9924M4.22056 3.97053L5.11815 4.86811M13.3436 6.90652C15.0522 8.61506 15.0522 11.3852 13.3436 13.0937C11.6351 14.8022 8.86499 14.8022 7.15645 13.0937C5.4479 11.3852 5.4479 8.61506 7.15645 6.90652C8.86499 5.19798 11.6351 5.19798 13.3436 6.90652Z",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_15263_8704" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "20",
          fill: "white",
          transform: "translate(0.25)"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }